<template>
    <v-app id="inspire">
        <v-content>
            <v-container
              fluid
              style="max-width: 900px"
            >
                <div class="headline mb-2 mt-5 text-left">Единовременные затраты: <b>{{ sumOneTimeCosts }} руб.</b></div>
                <div  class="mb-5">* с помощью галочек вы можете отказаться от части услуг или добавить новые</div>
                <div v-for="(item, index) in oneTimeCosts" :key="index" class="calc-table">
                    <div class="calc-table-row">
                        <div class="calc-table-row-label title">
                            <template>{{ item.titleText }}</template>
                        </div>
                        <div class="calc-table-row-price title">
                            {{ calcSum(item.subCat, index) }}
                        </div>
                    </div>

                    <div class="calc-table-row" v-for="(item, subIndex) in item.subCat" :key="subIndex" v-show="item.show"> <!-- v-show="item.show" -->
                        <div class="calc-table-row-label sub-title"> <!-- v-show="item.show" -->
                        
                            <v-checkbox
                                v-model="item.active"
                                v-if="!item.title"
                                class="checkbox-row"
                                color="primary"
                                :label="item.select ? '' : item.titleText"
                                @change="calcRemove(index, 'oneTimeCosts', item.id)"
                                :disabled="item.disabled"
                            ></v-checkbox>

                            <input 
                                v-model="item.inputCalc"
                                v-if="item.input"
                                :disabled="!item.active"
                                class="calc-table-input"
                                oninput="this.value = (()=>{
                                    this.value = this.value.replace(',','.').replace(/^\.|[^\d\.]|\.(?=.*\.)|^0+(?=\d)/g, '')
                                    if(this.value === '') {
                                        return 1
                                    } else if(this.value == 0) {
                                        return 1
                                    } else {
                                        return this.value.replace(/[^\d;]/g, '')
                                    }
                                })()"
                                @input="()=>{
                                    formulaCalc(subIndex, index, item, 'oneTimeCosts')
                                    calcRemove(index, 'oneTimeCosts')
                                }"
                            />
                            <span class="calc-table-select-block" v-if="item.select">
                            <v-select
                                :items="item.selectItems"
                                
                                class="calc-table-select"
                                dense
                                v-model="item.activeSelect"
                                item-value="value"
                                item-text="title"
                                @change="()=>{
                                    changeSelect(index, subIndex, 'oneTimeCosts', true)
                                    calcRemove(index, 'oneTimeCosts')
                                }"
                            >
                            </v-select>
                            </span>

                            <span style="margin: 15px">
                                <v-tooltip bottom v-if="item.helpText" max-width="300">
                                    <template v-slot:activator="{ on }">
                                        <v-icon color="primary" dark v-on="on">help</v-icon>
                                    </template>
                                    <span>{{item.helpText}}</span>
                                </v-tooltip>
                            </span>

                        </div>
                        <div class="calc-table-row-price sub-title"  :style="item.active ? 'opacity: 1': 'opacity: 0.3'"> <!-- v-show="item.show" -->
                            {{ Number(item.price.toFixed(0)).toLocaleString('ru') }}
                        </div>
                    </div>
                </div>


                <div class="headline mb-2 mt-5 pt-5 text-left">Ежемесячные затраты: <b>{{ sumMonthlyCosts }} руб.</b></div>
                <div class="mb-5">* с помощью галочек вы можете отказаться от части услуг или добавить новые</div>

                <div v-for="(item, index) in monthlyCosts" :key="index+'two'" class="calc-table">
                    <div class="calc-table-row">
                        <div class="calc-table-row-label title">
                            <template>{{ item.titleText }}</template>
                        </div>
                        <div class="calc-table-row-price title">
                            {{ calcSum(item.subCat, index) }}
                        </div>
                    </div>

                    <div class="calc-table-row" v-for="(item, subIndex) in item.subCat" :key="subIndex+'two'">
                        <div class="calc-table-row-label sub-title">
                            <v-checkbox
                                v-model="item.active"
                                v-if="!item.title"
                                class="checkbox-row"
                                color="primary"
                                :label="item.select ? '' : item.titleText"
                                @change="calcRemove(index, 'monthlyCosts', item.id)"
                                :disabled="item.disabled"
                            ></v-checkbox>

                            <input 
                                v-model="item.inputCalc"
                                v-if="item.input"
                                :disabled="!item.active"
                                class="calc-table-input"
                                @input="()=>{
                                    formulaCalc(subIndex, index, item, 'monthlyCosts')
                                    calcRemove(index, 'monthlyCosts')
                                }"
                                oninput="this.value = (()=>{
                                    this.value = this.value.replace(',','.').replace(/^\.|[^\d\.]|\.(?=.*\.)|^0+(?=\d)/g, '')
                                    if(this.value === '') {
                                        return 1
                                    } else if(this.value == 0) {
                                        return 1
                                    } else {
                                        return this.value.replace(/[^\d;]/g, '')
                                    }
                                })()"
                            />

                            <span class="calc-table-select-block" v-if="item.select">
                                <v-select
                                    :items="item.selectItems"
                                    v-if="item.select"
                                    class="calc-table-select"
                                    dense
                                    v-model="item.activeSelect"
                                    item-value="value"
                                    item-text="title"
                                    @change="()=>{
                                        changeSelect(index, subIndex, 'monthlyCosts');
                                        calcRemove(index, 'monthlyCosts');
                                    }"
                                ></v-select>
                            </span>

                            <span style="margin: 15px">
                                <v-tooltip bottom v-if="item.helpText" max-width="300">
                                    <template v-slot:activator="{ on }">
                                        <v-icon color="primary" dark v-on="on">help</v-icon>
                                    </template>
                                    <span>{{item.helpText}}</span>
                                </v-tooltip>
                            </span>
                            
                        </div>
                        <div class="calc-table-row-price sub-title" :style="item.active ? 'opacity: 1': 'opacity: 0.3'">
                            {{ Number(item.price.toFixed(0)).toLocaleString('ru') }}
                        </div>
                    </div>
                </div>
                <v-row
                    align="center"
                    justify="center"
                    style="margin-bottom: 100px"
                >
                    <v-btn
                        :disabled="!valid"
                        color="grey"
                        dark
                        class="mr-4"
                        @click="()=>{
                            this.$router.push({
                                name: 'step1',
                            })
                        }"
                    >
                        Назад
                    </v-btn>
                    <v-btn
                        :disabled="!valid"
                        color="success"
                        class="mr-4"
                        @click="()=>{
                            this.dataConvert()
                            this.stepTwo(this.convertData)
                            this.$router.push({
                                name: 'step3',
                                params: {
                                    dataConvert: this.convertData,
                                    data: this.$route.params.data,
                                }
                            })
                        }"
                    >
                        Далее
                    </v-btn>
                </v-row>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import { mapMutations } from 'vuex'
    import dataFile from '@/calcData/uk'
    import options from '@/calcData/options'

    export default {
        data() {
            return {
                active: 1,
                valid: true,
                checkbox: true,
                items: ['"1С: Бухгалтерия 8.3 Базовая версия"', '"1С: Бухгалтерия 8.3 ПРОФ"', ],
                oneTimeCosts: [],
                monthlyCosts: [],
                convertData: [
                    {
                        Name: "Единовременные затраты",
                        Items: []
                    },
                    {
                        Name: "Ежемесячные затраты",
                        Items: []
                    },
                ]
            }
        },
        mounted() {
            
            this.openStep()
        },
        computed: {
            sumOneTimeCosts() {
                let sum = this.oneTimeCosts.reduce((calc, item) => {
                    return item.price + calc
                }, 0)
                return Number(sum.toFixed(0)).toLocaleString('ru')
            },
            sumMonthlyCosts() {
                let sum = this.monthlyCosts.reduce((calc, item) => {
                    return item.price + calc
                }, 0)
                return Number(sum.toFixed(0)).toLocaleString('ru')
            },
        },
        methods: {
            ...mapMutations([
                'stepTwo'
            ]),
            validate () {
                if (this.$refs.form.validate()) {
                
                }
            },
            calcSum(array, index) {
                let sumActive = array.reduce((calc, item)=>{
                    return item.active ? item.price + calc : calc + 0
                }, 0)
                //this.oneTimeCosts[index].price = sumActive
                return Number(sumActive.toFixed(0)).toLocaleString('ru')
            },
            formulaCalc(subIndex, index, item, step) {
                let calc = eval(item.indFormula)
                this[step][index].subCat[subIndex].price = calc
            },
            calcRemove(index, data, id = null) {
                let sumActive =  this[data][index].subCat.reduce((calc, item)=>{
                    return item.active ? item.price + calc : calc + 0
                }, 0)
                this[data][index].price = sumActive

                //решение для диспетчерезации
                if(id === 5) {
                    this.monthlyCosts.forEach((item, index)=>{
                        if(item.id === 14) {
                            item.subCat.forEach((subItem, subIndex)=>{
                                if(subItem.id == 18) {
                                    subItem.active = !subItem.active
                                    this.calcRemove(index, 'monthlyCosts')
                                }
                            })
                        }
                    })
                } 
            },
            changeSelect(index, subIndex, step, accounting = false) {
                let activeSelect = this[step][index].subCat[subIndex].activeSelect
                this[step][index].subCat[subIndex].price =  this[step][index].subCat[subIndex].selectItems[activeSelect].price
                if(accounting)  this.oneTimeCosts[2].subCat[2].show = !this.oneTimeCosts[2].subCat[2].show
            },
            openStep() {
                if(this.$route.params.data) {
                    let optionsData = options(this.$route.params.data)
                    this.oneTimeCosts = optionsData.oneTimeCosts
                    console.log(optionsData.oneTimeCosts, 'единовременно')
                    this.monthlyCosts = optionsData.monthlyCosts
                    
                    for(let i = 0; i < this.oneTimeCosts.length; i++) {
                        this.calcRemove(i, 'oneTimeCosts')
                    }
                    for(let i = 0; i < this.oneTimeCosts.length; i++) {
                        this.calcRemove(i, 'monthlyCosts')
                    }
                }
            },
            dataConvert() {
                this.convertData = [
                    {
                        Name: "Единовременные затраты",
                        Items: []
                    },
                    {
                        Name: "Ежемесячные затраты",
                        Items: []
                    },
                ]
                
                for(let item of this.oneTimeCosts) {
                    let subItems = []
                    if(item.subCat.length) {
                        for(let subItem of item.subCat) {
                            if(subItem.active) {
                                if(subItem.select) {
                                    let name = subItem.selectItems[subItem.activeSelect].title
                                    subItems.push({
                                        Name: name,
                                        Sum: subItem.price
                                    })
                                } else {
                                    subItems.push({
                                        Name: subItem.titleText + ( subItem.input ?  ' - ' + subItem.inputCalc : ''),
                                        Sum: subItem.price
                                    })
                                }
                            }
                        }
                    }
                    if(subItems.length) {
                        this.convertData[0].Items.push({
                            Name: item.titleText,
                            Sum: item.price,
                            Items: subItems
                        })
                    }

                }

                for(let item of this.monthlyCosts) {
                    let subItems = []
                    if(item.subCat.length) {
                        for(let subItem of item.subCat) {
                            if(subItem.active) {
                                subItems.push({
                                    Name: subItem.titleText + ( subItem.input ?  ' - ' + subItem.inputCalc : ''),
                                    Sum: subItem.price
                                })
                            }
                        }
                    }
                    if(subItems.length) {
                        this.convertData[1].Items.push({
                            Name: item.titleText,
                            Sum: item.price,
                            Items: subItems
                        })
                    }
                }
                //console.log('this.convertData', JSON.parse(JSON.stringify(this.convertData)))
            }
        },
        watch: {
            '$route' (to) {
                //console.log('to.path', to.path)
                if( to.path == '/step2') {
                    this.openStep()
                }
            }
        }
    }
</script>

<style lang="sass" scoped>
    .calc-table
        margin-bottom: 40px
        &-row
            display: flex
            justify-content: space-between
            padding: 7px 20px
            &:nth-child(odd)
                background: #DFDFDF
            &:nth-child(2n)
                background: #ECECEC
        &-input
            background-color: #FFF
            width: 60px
            margin: 0 20px
            padding: 2px 5px
            &:disabled
                opacity: 0.4
        &-select
            margin: -6px 0px
            padding: 2px 0px
            &-block
                max-width: 600px
                display: block
                float: left
            

    .calc-table-row .title
        font-size: 17px !important

    .sub-title
        margin-left: 30px

    .v-select__selection--comma
        color: rgb(102, 102, 102) !important

    .checkbox-row
        float: left
        padding: 0
        margin: 2px
        height: 0

        
    @media (max-width: 900px)
        .checkbox-row
            height: auto
        .sub-title
            margin-left: 5px
            max-width: 84%
        .calc-table
            &-select
                &-block
                    max-width: 60%



</style>

<style>
    .v-select__selection--comma {
        color: rgb(102, 102, 102) !important;
    }
</style>